import React from 'react';
import { Checkbox } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';

import styles from './styles';

const CustomCheckBox = props => (
  <Checkbox
    color="default"
    {...props}
  />
);

export default withStyles(styles)(CustomCheckBox);
